// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--207ew","Tabs":"Tabs--2O-fQ"};